import * as React from "react";
import { z } from "zod";
import styled from "styled-components";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { MastheadBladeSchema } from "../../../schemas/blades/Masthead";
import { Blade } from "../../../components/Blade";
import { Backdrop, BackdropBackground } from "../../../components/Backdrop";
import { Media } from "../../../components/Media";
import { BladeHeader, BladeHeaderBody, BladeHeaderSupertitle } from "../../../components/BladeHeader";
import { RichText } from "../../../components/RichText";
import { BladeContent } from "../../../components/BladeContent";
import { CTA } from "../../../components/CTA";
export const TextMastheadContractSchema = MastheadBladeSchema.extend({
    type: z.literal("textMasthead"),
});
const _TextMasthead = (props) => {
    const { header, backdrop, ...otherProps } = props;
    const { title, supertitle, description } = header || {};
    const { background } = backdrop || {};
    const link = header?.links?.[0];
    return (React.createElement(Blade, { ...otherProps, className: [props.className, description && "hasDescription"].filter(Boolean).join(" "), "data-testid": "TextMasthead" },
        React.createElement(Backdrop, null,
            React.createElement(BackdropBackground, null, background && React.createElement(Media, { media: background, role: "presentation" }))),
        React.createElement(BladeContent, { width: "large" },
            React.createElement(BladeHeader, null,
                supertitle && React.createElement(BladeHeaderSupertitle, null, supertitle),
                React.createElement("h1", { "data-testid": "title" }, title),
                description && (React.createElement(BladeHeaderBody, null,
                    React.createElement(RichText, { ...description }))),
                link && (React.createElement("div", { className: "text-masthead--link" },
                    React.createElement(CTA, { "data-testid": "text-masthead-link-cta", variant: "primary", ...link })))))));
};
export const TextMasthead = styled(_TextMasthead) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=TextMasthead.js.map